var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9002 3.73356C12.5105 1.98934 10.385 1 8.09605 1C5.8071 1 3.68164 1.98934 2.29192 3.73356C0.302759 6.23282 0.302759 9.69533 2.29192 12.1946L8.09605 19.432L13.9002 12.1946C15.8894 9.69533 15.8894 6.23282 13.9002 3.73356V3.73356ZM8.09605 4.15005C10.1943 4.15005 11.911 5.79019 11.911 7.7948C11.911 9.79941 10.1943 11.4395 8.09605 11.4395C5.99785 11.4395 4.28113 9.79941 4.28113 7.7948C4.28113 5.79019 5.99785 4.15005 8.09605 4.15005Z",
    stroke: "#C4C4C4",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLocation);
export default __webpack_public_path__ + "static/media/filter_location.72e9e6aa3cd3e58bba85ce5f9ae619f3.svg";
export { ForwardRef as ReactComponent };